<template>
  <div v-if="hasBlocks" class="related-item">
    <div class="head-meta">
      <span class="template-name">{{ relatedItem.templateTitle }}</span>
      <span class="last-used">{{ $filters.short(relatedItem.used) }}</span>
      <a
        v-if="sharedoUrl"
        :href="sharedoUrl"
        target="_blank"
        title="Open in Sharedo"
      >
        <icon name="fa-external-link-square-alt" />
      </a>
    </div>
    <div class="blocks-used">
      <ul>
        <related-content-block-item
          v-for="block in filteredBlocks"
          :key="block.systemName"
          :block="block"
          @insert-block="(block) => $emit('insert-block', block)"
          @block-refresh="(block) => $emit('block-refresh', block)"
        />
      </ul>
    </div>
  </div>
</template>
<script>
import RelatedContentBlockItem from "./RelatedContentBlockItem.vue";
import { openWorkItem } from "@/util/urlBuilder";

export default {
  components: { RelatedContentBlockItem },
  props: {
    relatedItem: {
      required: true,
    },
    showTemplateAuthorBlocks: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    filteredBlocks: function () {
      return this.relatedItem.blocks.filter(
        (block) =>
          block.availableForDocumentAuthors ||
          (this.showTemplateAuthorBlocks && block.availableForTemplateAuthors)
      );
    },
    hasBlocks: function () {
      return this.filteredBlocks.length > 0;
    },
    sharedoUrl: function () {
      if (this.relatedItem.generationId) {
        return openWorkItem(this.relatedItem.generationId);
      }

      return "";
    },
  },
  emits: ["block-refresh", "insert-block"],
};
</script>
<style lang="scss" scoped>
@import "@/_css/variables.scss";

.related-item {
  background-color: $white;
  padding: 10px;
  margin-bottom: 10px;
  font-size: 0.8rem;
  border: 1px solid $gray-500;
  border-radius: $input-border-radius;

  & > .head-meta {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    font-weight: bold;

    & > .template-name {
      flex-grow: 1;
    }
  }

  & > .blocks-used {
    margin: 10px 0;

    & > ul {
      list-style: none;
      margin: 0px;
      padding: 0 0 0 10px;
    }
  }
}
</style>
